import React from 'react'
import Login from '../../components/Login/Login';
import './SigninPage.css';
const SigninPage = () => {
  return (
    <div className='signin'>
      <Login />
     
    </div>
  );
}

export default SigninPage
